import React from "react"
import styled from "styled-components"

export default function BackBtn({ content, onClick }) {
  return (
    // <Wrapper>
    <Btn onClick={onClick}>
      {content}
      {/* <button className="button">Back</button> */}
    </Btn>
    // </Wrapper>
  )
}
const Wrapper = styled.div`
  position: relative;
  display: flex;
`
const Btn = styled.button`
  width: 100%;
  height: auto;
  background-color: rgba(0, 0, 0, 0.425);
  backdrop-filter: blur(5px);
  padding: 16px 62px;
  position: relative;

  clip-path: polygon(
    0% 0%,
    calc(100% - 30px) 0%,
    100% calc(0% + 30px),
    100% 100%,
    0% 100%
  );
  font-size: 16px;
  transition: 0.3s;
  color: #00fff0;
  cursor: pointer;
  border: 1px solid #00fff0;
  &::before {
    content: "";
    position: absolute;
    right: -10px;
    top: 3px;
    width: 50px;
    height: 10px;
    transform: rotate(45deg);
    background-color: #00fff0;
    z-index: 1;
  }

  &:hover {
    background-color: #00fff0;
    color: #000;
    box-shadow: 0px 0px 30px #00fff0;
  }
`
